module.exports = __webpack_public_path__ + "static/media/dexy.11464288.jpg";